'use strict';

var self = module.exports = {

  init: function() {

    $(document).on('submit', 'form[name="contact"]', function (e) {
      e.preventDefault();

      if (global.artworkId == null) {

        $.fn.fullpage.moveTo(2);

      } else {

        $('[data-js="delivery-button"]').hide();
        $('[data-js="delivery-loading"]').append('<img src="assets/images/loading/loading-gear-orange.gif">');

        $.post('/submit-form?artworkId=' + global.artworkId, $(this).serializeArray(), function(output) {

          if (output.error) {
            $(document).find('.delivery__form').replaceWith($(output.form));
            global.updateGlobalThumbElement();
            if (global.thumb.attr('data-placeholder') == '1') {
              global.updateThumb(output.id);
            }

            /**
             * Ricreo la select dopo il reload degli errori
             */
            $('.selectize').selectize();
          } else {
            global.artworkId = null;
            dataLayer.push({
              event: 'click',
              context_submitted:'inviato'
            })
            $.fn.fullpage.moveSectionDown();
          }
        });

      }

    });

  }
};

self.init();
